import { useEffect, useRef } from "react";

import SearchInput from "common/components/SearchInput";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

export default function KeywordSearchInput({
  setKeywordSearchParam,
  keywordInputValue,
  setKeywordInputValue,
}: {
  setKeywordSearchParam: (keywordSearchParam: string) => void;
  keywordInputValue: string;
  setKeywordInputValue: (keywordInputValue: string) => void;
}) {
  const isDesktop = useTwBreakpoint("lg");
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (keywordInputValue) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(
        () => setKeywordSearchParam(keywordInputValue),
        800,
      );
      return () => clearTimeout(timeoutRef.current);
    }
    setKeywordSearchParam(keywordInputValue);
  }, [keywordInputValue]);

  return (
    <SearchInput
      placeholder="Search leads"
      onChange={(e) => setKeywordInputValue(e.target.value)}
      value={keywordInputValue}
      onClear={() => setKeywordInputValue("")}
      className="lg:max-w-72"
      variant={isDesktop ? "sm" : "lg"}
    />
  );
}
